const shipmentDocumentSourceEnum = {
	pulledFromSellerCloud: {
		value: 0,
		label: "Pulled from Seller Cloud"
	},
	uploaded: {
		value: 1,
		label: "Uploaded"
	},
	uploadedViaAPI: {
		value: 2,
		label: "Uploaded via API"
	},
	pulledFromBanyan: {
		value: 3,
		label: "Pulled from Banyan"
	},
	pulledFromPriority1: {
		value: 4,
		label: "Pulled from Priority1"
	}
};

export { shipmentDocumentSourceEnum };
